import { postAuthor } from "./types";

// TODO: Använd riktiga alt-texter även för dessa
export const getAuthorImage = (
  author: postAuthor,
  photoTranslation: string,
) => {
  let image = "";
  let alt = "";
  if (author.photoUrl) {
    image = author.photoUrl;
    alt = `${author.title}, ${photoTranslation}.`;
  }
  return { image, alt: alt || "" };
};
